import { autoserialize } from 'cerialize';

import { BaseDTO, IBaseDTO } from './base-dto';

export enum SurveyTrigger {
  donation_management_after_submit_resupply = 'donation_management_after_submit_resupply',
  donation_management_after_submit_charity = 'donation_management_after_submit_charity',
}

export const SurveyTriggerLabels = {
  donation_management_after_submit_resupply: 'Donation Management (Resupply owned)',
  donation_management_after_submit_charity: 'Donation Management (Charity owned)',
};

export enum SurveyType {
  text = 'text',
  select = 'select',
  select_other = 'select_other',
}

export const SurveyTypeLabels = {
  text: 'Text',
  select: 'Select',
  select_other: 'Select (with Other)',
};

export class Survey extends BaseDTO implements ISurvey {
  @autoserialize id: string;

  @autoserialize discarded_at?: string;
  @autoserialize created_at?: string;

  @autoserialize trigger: SurveyTrigger;

  @autoserialize question: string;
  @autoserialize input_type: SurveyType;

  @autoserialize answers?: string[];
  @autoserialize randomize?: boolean;

  constructor(payload?: ISurvey) {
    super(payload);
    this.id = payload?.id?.toString();
    this.discarded_at = payload?.discarded_at;
    this.created_at = payload?.created_at;
    this.trigger = payload?.trigger;

    this.question = payload?.question;
    this.input_type = payload?.input_type;

    this.answers = payload?.answers;
    this.randomize = payload?.randomize;
  }

  get isSelect(): boolean {
    return [SurveyType.select, SurveyType.select_other].includes(this.input_type);
  }

  get hasOther(): boolean {
    return [SurveyType.select_other].includes(this.input_type);
  }
}

export interface ISurvey extends IBaseDTO {
  id: string;

  discarded_at?: string;
  created_at?: string;

  trigger: SurveyTrigger;

  question: string;
  input_type: SurveyType;

  answers?: string[];
  randomize?: boolean;
}
